'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = generateScale;

var _tinycolor = require('tinycolor2');

var _tinycolor2 = _interopRequireDefault(_tinycolor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generateScale(color) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'P';

  var scale = {};

  var opacities = [0.04, 0.06, 0.09, 0.14, 0.3, 0.47, 0.7, 0.81];

  // Add opaque colors first.
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = opacities.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _ref = _step.value;

      var _ref2 = _slicedToArray(_ref, 2);

      var index = _ref2[0];
      var opacity = _ref2[1];

      var opaqueColor = _tinycolor2.default.mix('white', color, opacity * 100).toHexString();
      scale['' + prefix + (index + 1)] = opaqueColor;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  scale[prefix + '9'] = color;
  scale[prefix + '10'] = (0, _tinycolor2.default)(color).darken(15).toHexString();

  // Add opacity colors second.
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = opacities.entries()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _ref3 = _step2.value;

      var _ref4 = _slicedToArray(_ref3, 2);

      var _index = _ref4[0];
      var _opacity = _ref4[1];

      var opacityColor = (0, _tinycolor2.default)(color).setAlpha(_opacity).toString();
      scale['' + prefix + (_index + 1) + 'A'] = opacityColor;
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return scale;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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